import React from 'react'

import PersonAvatar, {
  ColorPersonAvatarProps,
  ImagePersonAvatarProps,
} from '../PersonAvatar'

import {
  Wrapper,
  AdditionalText,
  AvatarWrapper,
  Size,
} from './AvatarStack.styles'

type RenderType =
  | [string, OmitSafe<ColorPersonAvatarProps, 'size'>]
  | [string, OmitSafe<ImagePersonAvatarProps, 'size'>]

interface AvatarStackProps<T extends {}> {
  className?: string
  items: T[]
  size: Size
  renderItems: (item: T) => RenderType
}

const MAXIMUM_AVATAR_COUNT = 3

function AvatarStack<T extends {}>(props: AvatarStackProps<T>) {
  const { className, items, renderItems, size } = props
  const showAdditionalText = items.length > MAXIMUM_AVATAR_COUNT

  return (
    <Wrapper
      className={className}
      $size={size}
      $hasBackground={showAdditionalText}>
      {showAdditionalText && (
        <AdditionalText>+{items.length - 1}</AdditionalText>
      )}
      <AvatarWrapper>
        {items.map(item => {
          const [key, props] = renderItems(item)

          return <PersonAvatar size={size} key={key} {...props} />
        })}
      </AvatarWrapper>
    </Wrapper>
  )
}

export default AvatarStack
